export enum ConstraintStatus {
	NotMet = 'NotMet',
	PartiallyMet = 'PartiallyMet',
	FullyMet = 'FullyMet',
}
